var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteWithdraw = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/withdraw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/withdraw",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(15, 15) scale(-1, 1) rotate(-180) translate(-15, -15)",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(16.0015, 15.5083) scale(-1, 1) translate(-16.0015, -15.5083)translate(3.0029, 1.999)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(18.9572, 6.973) scale(-1, 1) rotate(-180) translate(-18.9572, -6.973)translate(11.9172, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0799409,0 L14.0799409,13.9450049 L13.0799409,13.9450049 L13.0799409,0.945004876 L1.07994091,0.945004876 L1.07994091,13.9450049 L0,13.9450049 L0,0 L14.0799409,0 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5199516,2.53545543 L11.5199516,13.9450049 L10.175945,13.9450084 C10.2179215,13.7401996 10.239957,13.528219 10.239957,13.311141 C10.239957,11.5607743 8.80727423,10.1418217 7.03997045,10.1418217 C5.27266667,10.1418217 3.83998388,11.5607743 3.83998388,13.311141 C3.83998388,13.5285691 3.86209055,13.7408834 3.9041992,13.9459994 L3.90398926,13.9444554 L2.55998926,13.9450049 L2.55998926,2.53545543 L11.5199516,2.53545543 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(10.7188, 16.2503) scale(-1, 1) rotate(-180) translate(-10.7188, -16.2503)translate(0, 5.4821)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94800498,-0.17150076 L3.74918338,-0.182081558 C3.21613572,-0.184617865 2.79617064,0.236060871 2.79871282,0.770003973 L2.83497318,8.31195029 C2.83753864,8.84589339 3.26156569,9.27062456 3.79461335,9.273184 L5.99343495,9.28374167 L5.94800498,-0.17150076 L5.94800498,-0.17150076 Z",
    id: "Path",
    transform: "translate(4.3961, 4.5508) scale(1, -1) rotate(-43) translate(-4.3961, -4.5508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66189492,2.53300331 C11.4652603,4.08940211 12.6436872,5.06712318 13.1971755,5.4661665 C15.6777185,7.25454069 16.4763815,7.48369974 17.0371593,8.00162194 C18.7593625,9.59221136 20.2261733,11.2823272 21.4375916,13.0719694 L13.7551166,13.0720033 L12.4769645,11.8914429 C12.0965648,11.540114 11.4767943,11.5415426 11.0909925,11.9184582 C10.6730809,12.3294773 10.6827652,12.9760162 11.0797041,13.3426203 L15.4129528,17.3447146 C16.289526,18.1542986 16.4402393,19.5049238 15.7542366,20.5290925 C15.594656,20.7642641 15.4185364,20.9841606 15.2098227,21.2058336 C14.8245051,21.6150762 14.2052188,21.6488317 13.80828,21.2822276 L11.4266471,19.0826032 C10.6493086,18.3646703 9.5678954,18.0353749 8.40475508,17.6943575 C7.19248164,17.3398416 5.94712996,16.9547754 4.89056332,16.1064723 C3.9497705,15.3650954 3.16952667,14.4532008 2.55031605,13.4031154 C1.89754297,12.2901527 2.02266833,10.843609 2.85510198,9.7952821 C2.85510198,9.7952821 2.85510198,9.7952821 2.83856286,9.78000693 L9.66189492,2.53300331 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteWithdraw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-withdraw.9b2423217e6704475b6f3b04939707b2.svg";